import styled from "styled-components";
import { media } from "../../theme";
import PageTitle from "./PageTitle";
import PageHeaderButton from "./Buttons/PageHeaderButton";

const PageHeader = ({
  pageTitle,
  subText,
  isButtoned = false,
  buttonText,
  buttonOnClick,
  buttonIcon,
  isButtonDisabled,
  isButtonLoading,
}: any) => {
  return (
    <Header>
      <TextWrapper>
        <PageTitle title={pageTitle} />
        {subText && <TitleSubText>{subText}</TitleSubText>}
      </TextWrapper>
      {isButtoned && (
        <PageHeaderButton
          icon={buttonIcon}
          title={buttonText}
          onClick={buttonOnClick}
          disabled={isButtonDisabled}
          loading={isButtonLoading}
        />
      )}
    </Header>
  );
};

export default PageHeader;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 30px;
  align-items: center;
  min-height: 44px; //header button width

  /*
   * Dar ekranda yan yana durmak zorunda kalan başlık ile buton birbirini
   * eziyordu (uzun başlıklarda buton iki satıra kırılıyordu). Alt alta iner ve
   * buton tam genişlik olur — telefonda asıl eylem zaten odur.
   */
  ${media.mobile} {
    flex-direction: column;
    align-items: stretch;
    gap: 16px;
    margin-bottom: 20px;

    button {
      width: 100% !important;
    }
  }
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;

  ${media.mobile} {
    gap: 10px;
  }
`;

const TitleSubText = styled.div`
  color: #a3a3a3;
  font-size: 16px;
  font-weight: 400;
  line-height: 19.36px;

  ${media.mobile} {
    font-size: 14px;
    line-height: 18px;
  }
`;
